package pl.finn.forms.wouip

import io.kvision.core.onEvent
import io.kvision.form.*
import io.kvision.form.check.CheckBox
import io.kvision.form.select.Select
import io.kvision.form.select.selectOption
import io.kvision.form.text.Text
import io.kvision.form.text.TextArea
import io.kvision.form.text.TomTypeahead
import pl.finn.forms.common.BlockList
import io.kvision.html.*
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import io.kvision.panel.SimplePanel
import io.kvision.state.bind
import io.kvision.utils.px
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.fk02.DynamicFieldsValidator

class WouipPanel : SimplePanel() {

    private val dynamicFieldsValidator = DynamicFieldsValidator()
    init {
        bind(Model.formularzStore) { state ->
            // Inicjalizacja powiązania (bindingu) między "store" a "state"

            main {
                // Tworzenie głównego bloku interfejsu użytkownika

                margin = 15.px
                id = "peupcontent"
                // Ustawienie marginesu i identyfikatora dla elementu

                state.bladZapisu?.let {
                    // Sprawdzenie, czy wystąpił błąd zapisu w stanie
                    div(it, className = "alert alert-danger") {
                        // Tworzenie diva z treścią błędu
                        role = "alert"
                    }
                }

                when (state.widok) {
                    // Warunek zależny od wartości pola `widok` w stanie
                    FormularzWidok.EDYCJA, FormularzWidok.NOWY -> {
                        // Jeśli `widok` jest równy EDYCJA lub NOWY
                        if (state.form != null) {
                            // Sprawdzenie, czy formularz w stanie nie jest nullem
                            val WouipBlockList = BlockList(dynamicFieldsValidator)
                            val WouipBlocks = WouipBlocks(dynamicFieldsValidator)
                            val formPanel = formPanel<WouipForm>(
                                type = FormType.HORIZONTAL, horizRatio = FormHorizontalRatio.RATIO_2, className = "mx-2 mx-md-5 mt-3",
                                condensed = true
                            ) {
                                // Tworzenie panelu formularza z konfiguracją

                                add(createButtonPanel(state, this@formPanel))
                                // Dodanie panelu przycisków do formularza

                                h1(
                                    "Wniosek o udostępnienie informacji publicznej", //tytuł
                                    className = "h1 text-center"
                                ) {
                                    tabindex = -1
                                }

                                val pocztaElektronicznaKontakt =
                                    Text(
                                        value = state.form.sposobUdostepnienia.wartosc,
                                        label = "Adres poczty elektronicznej"
                                    ).apply {
                                        placeholder = "Proszę podać adres e-mail"
                                        visible = state.form.sposobUdostepnienia.sposob == "Wnioskowaną informację proszę przesłać na adres poczty elektronicznej"
                                        onEvent {
                                            change = {
                                                state.form.sposobUdostepnienia.wartosc = self.value
                                            }
                                        }
                                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                        flabel.addCssClass("required-label")
                                    }



                                val polaAdresu =  Div().apply {
                                    visible = state.form.formaUdostepnienia.adres.wlasny
                                    lateinit var poleMiejscowosci: FormControl
                                    lateinit var polePoczty: FormControl
                                    lateinit var poleUlicy: FormControl

                                    add(
                                        dynamicFieldsValidator.add(
                                            Text(
                                                value = state.form.formaUdostepnienia.adres.nazwa,
                                                label = "Nazwa"
                                            ).apply {
                                                onEvent {
                                                    change = {
                                                        state.form.formaUdostepnienia.adres.nazwa = self.value
                                                    }
                                                }
                                                styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                                flabel.addCssClass("required-label")
                                            },
                                            { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                                            POLE_WYMAGANE,

                                        )
                                    )

                                    add(
                                        dynamicFieldsValidator.add(
                                            Text(
                                                value = state.form.formaUdostepnienia.adres.kodPocztowy,
                                                label = "Kod Pocztowy"
                                            ).apply {
                                                onEvent {
                                                    change = {
                                                        state.form.formaUdostepnienia.adres.kodPocztowy = self.value
                                                        Model.onEditPostalCodeRefresh(
                                                            state.form.formaUdostepnienia.adres.kodPocztowy, polePoczty as TomTypeahead,
                                                            poleMiejscowosci as TomTypeahead,
                                                            poleUlicy as TomTypeahead
                                                        )
                                                    }
                                                }
                                                styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                                flabel.addCssClass("required-label")
                                            },
                                            { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                                            POLE_WYMAGANE,
                                            "doWiadomosci"
                                        )
                                    )
                                    polePoczty = dynamicFieldsValidator.add(
                                        TomTypeahead(
                                            value = state.form.formaUdostepnienia.adres.poczta,
                                            label = "Poczta"
                                        ).apply {
                                            onEvent {
                                                change = {
                                                    state.form.formaUdostepnienia.adres.poczta = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                                        POLE_WYMAGANE,
                                        "doWiadomosci"
                                    )
                                    add(polePoczty)
                                    poleMiejscowosci = dynamicFieldsValidator.add(
                                        TomTypeahead(
                                            value = state.form.formaUdostepnienia.adres.miejscowosc,
                                            label = "Miejscowość"
                                        ).apply {
                                            onEvent {
                                                change = {
                                                    state.form.formaUdostepnienia.adres.miejscowosc = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                                        POLE_WYMAGANE,
                                        "doWiadomosci"
                                    )
                                    add(poleMiejscowosci)
                                    poleUlicy =
                                        TomTypeahead(
                                            value = state.form.formaUdostepnienia.adres.ulica,
                                            label = "Ulica"
                                        ).apply {
                                            onEvent {
                                                change = {
                                                    state.form.formaUdostepnienia.adres.ulica = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                        }

                                    add(poleUlicy)
                                    add(
                                        dynamicFieldsValidator.add(
                                            Text(
                                                value = state.form.formaUdostepnienia.adres.budynek,
                                                label = "Budynek"
                                            ).apply {
                                                onEvent {
                                                    change = {
                                                        state.form.formaUdostepnienia.adres.budynek = self.value
                                                    }
                                                }
                                                styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                                flabel.addCssClass("required-label")
                                            },
                                            { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
                                            POLE_WYMAGANE,
                                            "doWiadomosci"
                                        )
                                    )
                                    add(
                                        Text(
                                            value = state.form.formaUdostepnienia.adres.lokal,
                                            label = "Lokal"
                                        ).apply {
                                            onEvent {
                                                change = {
                                                    state.form.formaUdostepnienia.adres.lokal = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                        },

                                        )

                                }
                                val adresWlasny = Div().apply {
                                    visible = state.form.sposobUdostepnienia.sposob == "PocztaTrad"
                                    val checkbox = CheckBox(value = state.form.formaUdostepnienia.adres.wlasny, label = "Inny adres do kontaktu z Urzędem niż ten podany w adresie do korespondencji (jednocześnie oświadczasz, że rezygnujesz z dostarczania pism na skrzynkę PeUP).", rich = true)
                                    add(
                                        checkbox.apply {
                                            onEvent {
                                                change = {
                                                    state.form.formaUdostepnienia.adres.wlasny = self.value
                                                    if (self.value) {
                                                        polaAdresu.show()
                                                        val noweOswiadczenie = Oswiadczenia("Oświadczam, że rezygnujesz z dostarczania pism na skrzynkę PeUP")
                                                        state.form.oswiadczenia.add(noweOswiadczenie)
                                                    } else {
                                                        polaAdresu.hide()
                                                        val oswiadczenieDoUsuniecia = state.form.oswiadczenia.find { it.oswiadczenie == "Oświadczam, że rezygnujesz z dostarczania pism na skrzynkę PeUP" }
                                                        if (oswiadczenieDoUsuniecia != null) {
                                                            state.form.oswiadczenia.remove(oswiadczenieDoUsuniecia)}
                                                    }
                                                }
                                            }
                                        }
                                    )
                                    if (checkbox.value) {
                                        state.form.formaUdostepnienia.adres.wlasny = true
                                    }


                                    add(polaAdresu)
                                }
                               adresWlasny.hide()

                                val innaFormaUdostepnienia =
                                    Text(
                                        value = state.form.formaUdostepnienia.wartosc,
                                        label = "Inna forma udostępnienia"
                                    ).apply {
                                      placeholder = "Proszę podać inną formę udostępnienia"
                                        visible = state.form.formaUdostepnienia.forma == "w formie"
                                        onEvent {
                                            change = {
                                                state.form.formaUdostepnienia.wartosc = self.value
                                            }
                                        }
                                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                        flabel.addCssClass("required-label")
                                    }


                                val formaUdostepnieniaWidok = Select(
                                    value = state.form.formaUdostepnienia.forma,
                                    label = "Wybierz formę udostępnienia"
                                ).apply {
                                    placeholder = "Wybierz formę przekazania informacji publicznej"
                                    onEvent {
                                        change = {
                                            state.form.formaUdostepnienia.forma = self.value
                                            if (self.value == "Inna") {
                                                innaFormaUdostepnienia.show()
                                            } else {
                                                innaFormaUdostepnienia.hide()
                                            }
                                        }
                                    }
                                    for ((key, value) in wouipData.listOfOptionsForSharing) {
                                        selectOption(value = key, label = value)
                                        liveSearch = true
                                    }
                                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                    flabel.addCssClass("required-label")
                                }
                                dynamicFieldsValidator.add(formaUdostepnieniaWidok, { elem ->
                                    ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible))
                                }, POLE_WYMAGANE)
                                formaUdostepnieniaWidok.hide()
                                add(
                                    dynamicFieldsValidator.add(
                                        Text(
                                            value = state.form.temat,
                                            label = "Temat"
                                        ).apply {
                                            placeholder = "Proszę podać nagłówek dokumentu"
                                            onEvent {
                                                change = {
                                                    state.form.temat = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                add(
                                    dynamicFieldsValidator.add(
                                        Text(
                                            value = state.form.miejscowoscDokumentu,
                                            label = "Miejscowość"
                                        ).apply {
                                            placeholder = "Miejscowość"
                                            onEvent {
                                                change = {
                                                    state.form.miejscowoscDokumentu = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                           flabel.addCssClass("required-label")
                                        },
                                       { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                add(
                                    dynamicFieldsValidator.add(
                                        TextArea(
                                            value = state.form.zakres,
                                            label = "Zakres informacji",
                                            rows = 4
                                        ).apply {
                                            placeholder = "Na podstawie art. 2 ust. 1 i art. 10 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej (Dz. U. z 2016 r. poz. 1764 z późn. zm.), zwracam się z prośbą o udostępnienie informacji w zakresie:"
                                            onEvent {
                                                change = {
                                                    state.form.zakres = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                h4(
                                    "Sposób otrzymania informacji publicznej",
                                    className = "h4 text-left"
                                )
                                add(
                                    dynamicFieldsValidator.add(
                                        Select(
                                            value = state.form.sposobUdostepnienia.sposob,
                                            label = "Forma kontaktu"
                                        ).apply {
                                            placeholder = "Wybierz sposób otrzymania informacji publicznej"

                                            onEvent {
                                                change = {
                                                    state.form.sposobUdostepnienia.sposob = self.value
                                                    if (self.value == "email") {
                                                        pocztaElektronicznaKontakt.show()
                                                        adresWlasny.hide()
                                                        formaUdostepnieniaWidok.hide()
                                                    } else if (self.value == "PocztaTrad") {
                                                        adresWlasny.show()
                                                        formaUdostepnieniaWidok.show()
                                                        pocztaElektronicznaKontakt.hide()
                                                    }else if (self.value == "Osobisty") {
                                                        formaUdostepnieniaWidok.show()
                                                        pocztaElektronicznaKontakt.hide()
                                                        adresWlasny.hide()
                                                    }
                                                    else {
                                                        pocztaElektronicznaKontakt.hide()
                                                        adresWlasny.hide()
                                                        formaUdostepnieniaWidok.hide()
                                                    }
                                                   if (state.form.sposobUdostepnienia.sposob !== "PocztaTrad"){
                                                       state.form.formaUdostepnienia.adres.wlasny = false
                                                       state.form.oswiadczenia.remove(state.form.oswiadczenia.find { it.oswiadczenie == "Oświadczam, że rezygnujesz z dostarczania pism na skrzynkę PeUP" })
                                                       adresWlasny.hide()

                                                }

                                                }

                                            }
                                            for ((key, value) in wouipData.listOfOptionsForReturn) {
                                                selectOption(value = key,label = value)
                                                liveSearch = true
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                add(
                                    dynamicFieldsValidator.add(
                                        pocztaElektronicznaKontakt,
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!pocztaElektronicznaKontakt.visible) ) },
                                        POLE_WYMAGANE
                                     ))

                                add(adresWlasny)
                                add(formaUdostepnieniaWidok)
                                add(
                                    dynamicFieldsValidator.add(
                                        innaFormaUdostepnienia,
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!innaFormaUdostepnienia.visible) ) },
                                        POLE_WYMAGANE
                                    ))
                              add(WouipBlockList.generateModifiableList(
                                    state.form.oswiadczenia,
                                    WouipBlocks.blokOswiadczen,
                                    ::Oswiadczenia,
                                    "Oświadczenia",
                                    { iter -> "Oświadczenie $iter" }
                                ))
                                add(WouipBlockList.generateModifiableList(
                                    state.form.informacjeDodatkowe,
                                    WouipBlocks.blokInfoDodatkowe,
                                    ::InformacjeDodatkowe,
                                    "Informacje dodatkowe",
                                    { iter -> "Informacja $iter" }
                                ))
                                h4(
                                    "Podpis",
                                    className = "h4 text-left"
                                )
                                add(
                                        Text(
                                            value = state.form.podpis.zUpowaznienia,
                                            label = "Z upoważnienia"
                                        ).apply {
                                            // placeholder = "Tekst wewnątrz"
                                            onEvent {
                                                change = {
                                                    state.form.podpis.zUpowaznienia = self.value
                                                }
                                            }
                                        },
                                )
                                add(
                                    dynamicFieldsValidator.add(
                                        Text(
                                            value = state.form.podpis.imieNazwiskoGrupa.imie,
                                            label = "Imię"
                                        ).apply {
                                            // placeholder = "Tekst wewnątrz"
                                            onEvent {
                                                change = {
                                                    state.form.podpis.imieNazwiskoGrupa.imie = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                add(
                                    dynamicFieldsValidator.add(
                                        Text(
                                            value = state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonPierwszy,
                                            label = "Nazwisko Pierwszy Człon"
                                        ).apply {
                                            // placeholder = "Tekst wewnątrz"
                                            onEvent {
                                                change = {
                                                    state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonPierwszy = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                add(

                                    Text(
                                        value = state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonDrugi,
                                        label = "Nazwisko Drugi Człon"
                                    ).apply {
                                        // placeholder = "Tekst wewnątrz"
                                        onEvent {
                                            change = {
                                                state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonDrugi = self.value
                                            }
                                        }
                                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                    }
                                )

                                add(

                                    Text(
                                        value = state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonTrzeci,
                                        label = "Nazwisko Trzeci Człon"
                                    ).apply {
                                        // placeholder = "Tekst wewnątrz"
                                        onEvent {
                                            change = {
                                                state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonTrzeci = self.value
                                            }
                                        }
                                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                    }
                                )

                                add(
                                    dynamicFieldsValidator.add(
                                        Text(
                                            value = state.form.podpis.stanowisko,
                                            label = "Stanowisko"
                                        ).apply {
                                            // placeholder = "Tekst wewnątrz"
                                            onEvent {
                                                change = {
                                                    state.form.podpis.stanowisko = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                // Miejsce na pola formularza [end]
                            }
                        }
                    }
                    else -> {}
                }
            }
        }
    }
    private fun createButtonPanel(state: Formularz, reference: FormPanel<WouipForm>): Div {
        return (
                Div(className = "form-group my-3") {
                    div(className = "row") {
                        div(className = "col-lg-6") {
                            div(className = "row") {
                                div(className = "col-sm-6 py-2") {
                                    button(
                                        "Zapisz dokument",
                                        "far fa-save fa-3x d-block",
                                        ButtonStyle.SUCCESS, className = "w-100"
                                    ).onClick {
                                        val referenceData = state.form
                                        // Dokument zapisze bez walidacji
                                        referenceData?.let { it1 -> Model.zapisz(it1, null) }
                                    }
                                }
                                div(className = "col-sm-6 py-2") {
                                    button("Sprawdź dokument", "fas fa-tasks fa-3x d-block", className = "w-100").onClick {
                                        val isValidatedDynamic = dynamicFieldsValidator.validate()
                                        if (/*isValidatedStatic &&*/ isValidatedDynamic) {
                                            Alert.show(
                                                "Sprawdzenie dokumentu",
                                                "Dokument jest poprawny.<br/>Wszystkie pola wypełnione są prawidłowo.",
                                                rich = true
                                            )
                                        } else {
                                            Alert.show(
                                                "Sprawdzenie dokumentu",
                                                "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
                                                rich = true
                                            )
                                        }
                                        Model.sprawdz()
                                    }
                                }
                            }
                        }
                        div(className = "col-lg-6") {
                            div(className = "row") {
                                div(className = "col-sm-6 py-2") {
                                    button("Podgląd dokumentu", "fas fa-eye fa-3x d-block", className = "w-100").onClick {
                                        val referenceData = state.form /*getReferenceData(reference, state)*/
                                        referenceData?.let { it1 -> Model.podglad(it1, this) }
                                    }
                                }
                                div(className = "col-sm-6 py-2") {
                                    button(
                                        "Anuluj",
                                        "fas fa-times fa-3x d-block",
                                        ButtonStyle.SECONDARY, className = "w-100"
                                    ).onClick {
                                        Confirm.show(
                                            "Potwierdzenie",
                                            "Czy anulować edycję formularza i powrócić do poprzedniej strony?",
                                            yesTitle = "Tak",
                                            noTitle = "Nie"
                                        ) {
                                            Model.anuluj()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                )
    }

}
